export default "__VITE_ASSET__4012b61a__"